import Checkbox from './checkbox';
import { withError } from '../hoc/withError';

export { Checkbox as CheckboxBase };
export default withError(Checkbox);
